import classNames from 'classnames'
import times from 'lodash/times'
import PropTypes from 'prop-types'
import React from 'react'

import '../../../scss/components/_carousel-decorators.scss'

const Bullets = ({currentSlide, goToSlide, modifier, slideCount, trackingCall}) => (
  <ul
    className={classNames('c-carousel-bullets', {
      [`c-carousel-bullets--${modifier}`]: modifier,
    })}
  >
    {times(slideCount).map((index) => (
      <li className="c-carousel-bullets__list-item" key={index}>
        <button
          className={classNames('c-carousel-bullets__button', {
            'is--current-slide': currentSlide === index,
          })}
          onClick={() => {
            goToSlide(index)
            trackingCall()
          }}
          type="button"
        >
          <span className="u-sr-only">Go to image {index + 1}</span>
        </button>
      </li>
    ))}
  </ul>
)

Bullets.propTypes = {
  currentSlide: PropTypes.number,
  goToSlide: PropTypes.func.isRequired,
  modifier: PropTypes.string,
  slideCount: PropTypes.number.isRequired,
  trackingCall: PropTypes.func.isRequired,
}

export default Bullets
